function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "#2ECF62",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M8.25 14.717a4.15 4.15 0 0 1-.973-2.685c0-1.058.39-2.022 1.029-2.748M18.85 6A9.168 9.168 0 0 1 21 11.928c0 2.338-.86 4.468-2.272 6.072M15.75 9.283a4.15 4.15 0 0 1 .973 2.685c0 1.058-.39 2.022-1.029 2.748M5.148 18A9.167 9.167 0 0 1 3 12.072C3 9.734 3.86 7.604 5.272 6M12 12.585a.576.576 0 0 1-.567-.585c0-.323.254-.585.567-.585.313 0 .567.262.567.585a.576.576 0 0 1-.567.585"
});

var SvgManagment = function SvgManagment(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgManagment, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/managment.41a9383c.svg";
export { ForwardRef as ReactComponent };